module.exports = __webpack_public_path__ + "img/RNM_2022-logo.569665a6.png";